<template>
  <div class="page-table-layout accruals-data-page" data-testid="accruals-data-page">
    <v-card class="all-width flex-card shadow-off" :loading="loading" :disabled="loading" loader-height="2">
      <v-card-text class="page-table-layout__body accruals-data-page__body">
        <accruals-workspace-header
          title="Data"
          subtitle="Source data behind this cycle's population"
          show-refresh
          :refresh-loading="headerRefreshing"
          @back="goBack"
          @refresh="onHeaderRefresh"
        />

        <accruals-data-workspace ref="dataWorkspace" @refreshing="headerRefreshing = $event" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AccrualsWorkspaceHeader from './components/AccrualsWorkspaceHeader.vue';
import AccrualsDataWorkspace from './components/AccrualsDataWorkspace.vue';
import { ACCRUALS_ROUTES } from './accrualsPageConstants';

export default {
  name: 'AccrualsData',
  components: {
    AccrualsWorkspaceHeader,
    AccrualsDataWorkspace,
  },
  data() {
    return {
      headerRefreshing: false,
    };
  },
  computed: {
    projectId() {
      return this.$route.params.id;
    },
    loading() {
      return !!this.$store.state.m_financialclose?.accruals?.loading;
    },
  },
  created() {
    this.$store.commit('accruals/setError', null);
  },
  beforeDestroy() {
    this.$store.commit('accruals/setError', null);
  },
  methods: {
    goBack() {
      this.$nova.gotoLink({ path: ACCRUALS_ROUTES.home(this.projectId) });
    },
    async onHeaderRefresh() {
      if (this.$refs.dataWorkspace?.refreshCurrentTab) {
        await this.$refs.dataWorkspace.refreshCurrentTab();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsData.scss';
</style>
